<template>
  <CreateEditBidderProjectModal
    v-if="showCreateEditBidderProjectModal"
    :projectId="projectId"
    :projectBidderId="projectBidderIdSelected"
    @closeModal="closeModal"
  />
  <DeleteBidderProjectModal
    v-if="showDeleteBidderProjectModal"
    :projectId="projectId"
    :projectBidderId="projectBidderIdSelected"
    @closeModal="closeModal"
  />
  <CreateEditBidderPartnerModal
    v-if="showCreateEditBidderPartnerModal"
    :type="typeBidder"
    :bidderPartnerId="bidderPartnerIdSelected"
    @closeModal="closeModal"
  />
  <CreateEditResponsibleModal
    v-if="showCreateEditResponsibleModal"
    :bidderPartnerId="bidderPartnerIdSelected"
    :responsibleId="responsibleIdSelected"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Proponentes</h6>
      <div v-if="canEditProject" class="ms-auto">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          title="Adicionar Proponente ao Sumário Executivo"
          @click="createEditBidderProject()"
        >
          Adicionar Proponente
        </button>
      </div>
    </div>
    <div class="card-body pb-1">
      <ListBiddersProject
        :bidders="bidders"
        @editBidderProject="createEditBidderProject"
        @deleteBidderProject="deleteBidderProject"
        @editBidderPartner="editBidderPartner"
        @editResponsible="editResponsible"
      />
    </div>
  </div>
</template>

<script>
import CreateEditBidderProjectModal from '@/components/projects/bidders/CreateEditBidderProjectModal.vue'
import DeleteBidderProjectModal from '@/components/projects/bidders/DeleteBidderProjectModal.vue'
import CreateEditBidderPartnerModal from '@/components/biddersPartners/CreateEditBidderPartnerModal.vue'
import CreateEditResponsibleModal from '@/components/biddersPartners/CreateEditResponsibleModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListBiddersProject from '@/components/projects/bidders/ListBiddersProject.vue'
import { mapGetters } from 'vuex'
import TypeBidderPartnerEnum from '@/enum/typeBidderPartnerEnum'

export default {
  name: 'BiddersProject',

  components: {
    CreateEditBidderProjectModal,
    DeleteBidderProjectModal,
    CreateEditBidderPartnerModal,
    CreateEditResponsibleModal,
    LoadingData,
    ListBiddersProject,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditBidderProjectModal: false,
      showDeleteBidderProjectModal: false,
      showCreateEditBidderPartnerModal: false,
      showCreateEditResponsibleModal: false,
      bidders: [],
      projectBidderIdSelected: null,
      bidderPartnerIdSelected: null,
      responsibleIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['canEditProject']),

    typeBidder() {
      return TypeBidderPartnerEnum.BIDDER
    },
  },

  methods: {
    async getBidders() {
      try {
        this.bidders = await this.$store.dispatch(
          'getProjectBidders',
          this.projectId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditBidderProject(projectBidderId) {
      this.projectBidderIdSelected = projectBidderId || null
      this.showCreateEditBidderProjectModal = true
    },

    deleteBidderProject(projectBidderId) {
      this.projectBidderIdSelected = projectBidderId
      this.showDeleteBidderProjectModal = true
    },

    editBidderPartner(bidderPartnerId) {
      this.bidderPartnerIdSelected = bidderPartnerId
      this.showCreateEditBidderPartnerModal = true
    },

    editResponsible(responsible) {
      this.bidderPartnerIdSelected = responsible.bidderPartnerId
      this.responsibleIdSelected = responsible.responsibleId
      this.showCreateEditResponsibleModal = true
    },

    closeModal(loadListBidders) {
      if (loadListBidders) {
        this.getBidders()
      }
      this.showCreateEditBidderProjectModal = false
      this.showDeleteBidderProjectModal = false
      this.showCreateEditBidderPartnerModal = false
      this.showCreateEditResponsibleModal = false
    },
  },

  mounted() {
    this.getBidders()
  },
}
</script>
